import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Link } from "components/core/Link";
import "./Crumb.scss";

const Crumb = ({ label, href, isLast, variant }) => (
	<span className={classNames({"crumb": variant === "default"}, { "crumb-v2": variant === "v2" })}>
		{isLast ? (
			label
		) : (
			<Link
				href={href}
				weight="semiBold"
				underline
				color="blue"
				hover
				className={classNames({"crumb-link-v2": variant === "v2"})}
			>
				{label}
			</Link>
		)}
	</span>
);

Crumb.defaultProps = {
	href: "",
	isLast: false,
	variant: "default"
};

Crumb.propTypes = {
	label: PropTypes.string.isRequired,
	href: PropTypes.string,
	isLast: PropTypes.bool,
	variant: PropTypes.oneOf(["default", "v2"])
};

export default Crumb;
